import { render } from "./SelectableParticipant.vue?vue&type=template&id=9fbf87b8&scoped=true"
import script from "./SelectableParticipant.vue?vue&type=script&lang=js"
export * from "./SelectableParticipant.vue?vue&type=script&lang=js"

import "./SelectableParticipant.vue?vue&type=style&index=0&id=9fbf87b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbf87b8"]])

export default __exports__